import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('benefits_set_csv_export', '/benefits_set_csv_exports')
const reducer = generator.generate()

export default reducer
